import { render, staticRenderFns } from "./AccessItem.vue?vue&type=template&id=5b7f6096&scoped=true&"
import script from "./AccessItem.vue?vue&type=script&lang=js&"
export * from "./AccessItem.vue?vue&type=script&lang=js&"
import style0 from "./AccessItem.vue?vue&type=style&index=0&id=5b7f6096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7f6096",
  null
  
)

export default component.exports